import { ChipBox, ChipText } from './styles'

export const Chip = {
  Root: ChipBox,
  Text: ChipText,
}
